<!-- 譲渡前のダイアログ -->
<template>
  <div>
    <ItemDialog ref="redemptionConfirmation" image-type="alert">
      <template #content-area>
        <p style="text-align: center">引き換えてもよろしいですか？</p>
      </template>
      <template #button-area>
        <ItemButton
          label="OK"
          action-type="btn-primary"
          @clicked="handleClick"
        />

        <ItemButton
          label="キャンセル"
          action-type="btn-cancel"
          @clicked="closeDialog"
        />
      </template>
    </ItemDialog>
    <!-- 譲渡前のダイアログ -->
  </div>
</template>

<script>
export default {
  name: "DialogRedemptionConfirmation",
  props: {
    count: {
      type: Number,
      required: false,
      default: null,
    },
  },
  methods: {
    openDialog() {
      this.$refs.redemptionConfirmation.open();
    },
    closeDialog() {
      this.$refs.redemptionConfirmation.close();
    },
    handleClick() {
      this.closeDialog();
      this.$emit("clicked");
    },
  },
};
</script>
